import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  scrollToTop() {
    window.scrollTo(0, 0)
  }
}
